<div class="mb-2">

  <div class="d-flex align-items-center justify-content-between">
    <div class="col-md-6">
      <a [href]="url" target="_blank" style="cursor: pointer;">
        <ng-container *ngIf="imagemLoja; else logo">
          <img class="avatar" [src]="imagemLoja" alt="imagemLoja">
        </ng-container>
        <ng-template #logo>
          <img class="avatar" src="assets/img/logo_krabo.png" alt="logoKrabo">
        </ng-template>
      </a>
    </div>
    <div class="col-md-6 text-end">
      <p class="font-500 nome">{{nomeEntidade}}</p>
      <p class="font-500 cpf">{{ssn}}</p>
    </div>

  </div>
  <hr class="mt-4">
